import React from 'react'
import BrandLayout from '../components/Layouts/BrandLayout'
import AuthorizationProviderContainer from '../containers/AuthorizationProvider/AuthorizationProvider.container'
import CancelQuoteDialogContainer from '../containers/CancelQuoteDialog/CancelQuoteDialog.container'
import ExtendQuoteClosingDateDialogContainer from '../containers/ExtendQuoteClosingDateDialog/ExtendQuoteClosingDateDialog.container'
import OnboardingDialogContainer from '../containers/OnboardingDialog/OnboardingDialog.container'
import ProtectByAccessToken from '../components/Security/ProtectByAccessToken'
import QuoteBidSellerContainer from '../containers/QuoteBidSeller/QuoteBidSeller.container'
import QuoteBasicInformation from '../containers/QuoteBasicInformation/QuoteBasicInformation.container'
import SendSellerQuoteDialog from '../containers/SendSellerQuoteDialog/SendSellerQuoteDialog.container'

/**
 * The Quote Offer's page.
 */
const QuoteBidPage = () => {
  return (
    <AuthorizationProviderContainer>
      <ProtectByAccessToken>
        <BrandLayout>
          <QuoteBasicInformation />
          <QuoteBidSellerContainer />
          <SendSellerQuoteDialog />
          <ExtendQuoteClosingDateDialogContainer />
          <CancelQuoteDialogContainer />
          <OnboardingDialogContainer />
        </BrandLayout>
      </ProtectByAccessToken>
    </AuthorizationProviderContainer>
  )
}

export default QuoteBidPage
